import { useMemo } from "react";
import { useCommerce } from "..";
export function formatPrice({ amount , currencyCode , locale , withDecimals  }) {
    const formatCurrency = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: withDecimals ? 2 : 0,
        maximumFractionDigits: 2
    });
    return formatCurrency.format(amount);
}
export function formatVariantPrice({ amount , baseAmount , currencyCode , locale , withDecimals  }) {
    const hasDiscount = baseAmount > amount;
    const formatDiscount = new Intl.NumberFormat(locale, {
        style: "percent"
    });
    const discount = hasDiscount ? formatDiscount.format((baseAmount - amount) / baseAmount) : null;
    const price = formatPrice({
        amount,
        currencyCode,
        locale,
        withDecimals
    });
    const basePrice = hasDiscount ? formatPrice({
        amount: baseAmount,
        currencyCode,
        locale,
        withDecimals
    }) : null;
    return {
        price,
        basePrice,
        discount
    };
}
export default function usePrice(data) {
    const { amount , baseAmount , currencyCode , withDecimals  } = data ?? {};
    const additional = (data == null ? void 0 : data.additional) ?? 0;
    const { locale  } = useCommerce();
    const value = useMemo(()=>{
        if (typeof amount !== "number" || !currencyCode) return "";
        return baseAmount ? formatVariantPrice({
            amount: amount + additional,
            baseAmount,
            currencyCode,
            locale,
            withDecimals
        }) : formatPrice({
            amount: amount + additional,
            currencyCode,
            locale,
            withDecimals
        });
    }, [
        amount,
        baseAmount,
        currencyCode,
        additional
    ]);
    return typeof value === "string" ? {
        price: value
    } : value;
};
